import { useEffect, useMemo } from 'react';
import { useTranslator } from 'tradera/lang/translate';
import {
    selectAvailableShippingCountryCodes,
    selectShippingCountry,
    selectIsLoadingAvailableShippingCountries,
    selectHasLoadedAvailableShippingCountries
} from 'tradera/state/shipping-region/selectors';
import {
    updateShippingRegion,
    getAvailableShippingCountries
} from 'tradera/state/shipping-region/actions';
import { ShippingCountrySelectDropdown } from './shipping-country-select-dropdown';
import Load from '@tradera/blueprint/theme/icons2/loading.svg?jsx';
import { mapCountryCodeToCountryKey } from 'tradera/localization/countries';
import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';

export const ShippingCountrySelect = () => {
    const { t } = useTranslator();
    const dispatch = useAppDispatch();
    const shippingCountry = useAppSelector(selectShippingCountry);
    const shippingCountryCodes = useAppSelector(
        selectAvailableShippingCountryCodes
    );
    const isLoadingAvailableShippingCountries = useAppSelector(
        selectIsLoadingAvailableShippingCountries
    );
    const showShippingCountries =
        useAppSelector(selectHasLoadedAvailableShippingCountries) &&
        !isLoadingAvailableShippingCountries;

    const shippingCountries = useMemo(
        () =>
            shippingCountryCodes.map((countryCodeIso2) => ({
                countryCodeIso2,
                name: t(mapCountryCodeToCountryKey(countryCodeIso2))
            })),
        [t, shippingCountryCodes]
    );
    useEffect(() => {
        dispatch(getAvailableShippingCountries());
    }, [dispatch]);

    return (
        <div className="p-2">
            <span className="d-flex align-items-center mb-1">
                <strong>{t('siteHeader_shippingCountry')}</strong>
            </span>
            {isLoadingAvailableShippingCountries && (
                <div className="w-100 d-flex justify-content-center">
                    <Load className="icon icon-spin mt-4 mb-5" />
                </div>
            )}
            {showShippingCountries && (
                <ShippingCountrySelectDropdown
                    relative
                    shippingCountries={shippingCountries}
                    selectedShippingCountryCodeIso2={
                        shippingCountry.countryCodeIso2
                    }
                    onSelect={(countryCodeIso2) => {
                        dispatch(updateShippingRegion(countryCodeIso2));
                    }}
                />
            )}
        </div>
    );
};
